import type { Icon } from 'ngxi'

export const miAdd: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 4a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2h-6v6a1 1 0 1 1-2 0v-6H5a1 1 0 1 1 0-2h6V5a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miArchive: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2a2 2 0 0 1-1.017 1.742Q21 8.868 21 9v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9q0-.131.017-.258A2 2 0 0 1 2 7zm18 2V5H4v2zM5 9v10h14V9zm3 3a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miArrowDown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 4a1 1 0 0 1 1 1v11.586l4.293-4.293a1 1 0 0 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 1 1 1.414-1.414L11 16.586V5a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miArrowLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11.707 5.293a1 1 0 0 1 0 1.414L7.414 11H19a1 1 0 1 1 0 2H7.414l4.293 4.293a1 1 0 0 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miArrowLeftDown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17.707 6.293a1 1 0 0 1 0 1.414L9.414 16H15a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1V9a1 1 0 1 1 2 0v5.586l8.293-8.293a1 1 0 0 1 1.414 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miArrowLeftUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 9.414V15a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H9.414l8.293 8.293a1 1 0 0 1-1.414 1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miArrowRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12.293 5.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414L16.586 13H5a1 1 0 1 1 0-2h11.586l-4.293-4.293a1 1 0 0 1 0-1.414\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miArrowRightDown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6.293 6.293a1 1 0 0 1 1.414 0L16 14.586V9a1 1 0 1 1 2 0v8a1 1 0 0 1-1 1H9a1 1 0 1 1 0-2h5.586L6.293 7.707a1 1 0 0 1 0-1.414\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miArrowRightUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 7a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0V9.414l-8.293 8.293a1 1 0 0 1-1.414-1.414L14.586 8H9a1 1 0 0 1-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miArrowUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 4a1 1 0 0 1 .707.293l6 6a1 1 0 0 1-1.414 1.414L13 7.414V19a1 1 0 1 1-2 0V7.414l-4.293 4.293a1 1 0 0 1-1.414-1.414l6-6A1 1 0 0 1 12 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miAttachment: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19.463 5.576c-.688-.75-1.929-.796-2.756.031l-8.1 8.1c-.21.21-.21.476 0 .686s.476.21.686 0l6.7-6.7a1 1 0 0 1 1.414 1.414l-6.7 6.7a2.45 2.45 0 0 1-3.514 0a2.45 2.45 0 0 1 0-3.514l8.1-8.1c1.567-1.568 4.115-1.619 5.63.015c1.552 1.569 1.597 4.104-.03 5.613l-9.486 9.486c-2.19 2.19-5.624 2.19-7.814 0s-2.19-5.624 0-7.814l8.1-8.1a1 1 0 0 1 1.414 1.414l-8.1 8.1c-1.41 1.41-1.41 3.576 0 4.986s3.576 1.41 4.986 0l9.5-9.5l.031-.03c.75-.687.796-1.929-.031-2.756z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miBackspace: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M17.707 8.293a1 1 0 0 1 0 1.414L15.414 12l2.293 2.293a1 1 0 0 1-1.414 1.414L14 13.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L12.586 12l-2.293-2.293a1 1 0 1 1 1.414-1.414L14 10.586l2.293-2.293a1 1 0 0 1 1.414 0\"/><path fill-rule=\"evenodd\" d=\"M22 5a1 1 0 0 0-1-1H9.46a2 2 0 0 0-1.519.698l-5.142 6a2 2 0 0 0 0 2.604l5.142 6A2 2 0 0 0 9.46 20H21a1 1 0 0 0 1-1zm-2 13H9.46l-5.143-6L9.46 6H20z\" clip-rule=\"evenodd\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miBan: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5.68 7.094A8 8 0 0 0 16.905 18.32zM7.094 5.68L18.32 16.906A8 8 0 0 0 7.094 5.68M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miBarChart: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm16 0H5v14h14zm-7 2a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1m4 2a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1m-8 2a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miBarChartAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 4a1 1 0 0 1 1 1v14a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1m5 4a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1M7 12a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miBoard: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm6 0H4v14h4zm2 0v14h4V5zm6 0v14h4V5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miBold: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h6.5a4.5 4.5 0 0 0 1.545-8.728A4.5 4.5 0 0 0 11.5 4zm4.5 7H8V6h3.5a2.5 2.5 0 0 1 0 5M8 13h5.5a2.5 2.5 0 0 1 0 5H8z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miBook: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 6.633q.21-.085.503-.181A9.8 9.8 0 0 1 7.5 6a9.8 9.8 0 0 1 2.997.452q.293.096.503.181v10.88A11.8 11.8 0 0 0 7.5 17c-1.46 0-2.649.248-3.5.513zm8-1.748a9 9 0 0 0-.888-.337A11.8 11.8 0 0 0 7.5 4c-1.526 0-2.755.271-3.612.548a9 9 0 0 0-1.001.389a6 6 0 0 0-.357.18l-.025.014l-.009.005l-.003.002h-.001c-.002.002-.247.147-.002.002A1 1 0 0 0 2 6v13a1 1 0 0 0 1.51.86l-.005.003h.001l.002-.001l.001-.001l.037-.02q.056-.03.182-.09c.17-.078.43-.188.775-.3A9.8 9.8 0 0 1 7.5 19a9.8 9.8 0 0 1 2.997.451a7 7 0 0 1 .775.3a4 4 0 0 1 .223.112m0 0l-.002-.001l-.001-.001c.314.185.704.185 1.018 0l.037-.02q.056-.03.182-.09a7 7 0 0 1 .775-.3A9.8 9.8 0 0 1 16.5 19a9.8 9.8 0 0 1 2.997.451a7 7 0 0 1 .775.3a4 4 0 0 1 .219.11A1 1 0 0 0 22 19V6a1 1 0 0 0-.49-.86l-.002-.001h-.001l-.003-.003l-.01-.005l-.024-.014a6 6 0 0 0-.357-.18a9 9 0 0 0-1-.389A11.8 11.8 0 0 0 16.5 4c-1.525 0-2.755.271-3.612.548a9 9 0 0 0-.888.337m8 1.748v10.88A11.8 11.8 0 0 0 16.5 17c-1.46 0-2.649.248-3.5.513V6.633q.21-.085.503-.181A9.8 9.8 0 0 1 16.5 6a9.8 9.8 0 0 1 2.997.452q.293.096.503.181m.49.228l.005.002h-.001zm0 13l.004.002l-.002-.002\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miBookmark: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v17a1 1 0 0 1-1.581.814L12 17.229l-6.419 4.585A1 1 0 0 1 4 21zm14 0H6v15.057l5.419-3.87a1 1 0 0 1 1.162 0L18 19.056z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCalendar: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 2a1 1 0 0 1 1 1v1h4V3a1 1 0 1 1 2 0v1h3a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h3V3a1 1 0 0 1 1-1M8 6H5v3h14V6h-3v1a1 1 0 1 1-2 0V6h-4v1a1 1 0 0 1-2 0zm11 5H5v8h14z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCall: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.833 4h4.49L9.77 7.618l-2.325 1.55A1 1 0 0 0 7 10c.003.094 0 .001 0 .001v.021a2 2 0 0 0 .006.134q.008.124.035.33c.039.27.114.642.26 1.08c.294.88.87 2.019 1.992 3.141s2.261 1.698 3.14 1.992c.439.146.81.22 1.082.26a4 4 0 0 0 .463.04l.013.001h.008s.112-.006.001 0a1 1 0 0 0 .894-.553l.67-1.34l4.436.74v4.32c-2.111.305-7.813.606-12.293-3.874S3.527 6.11 3.833 4m5.24 6.486l1.807-1.204a2 2 0 0 0 .747-2.407L10.18 3.257A2 2 0 0 0 8.323 2H3.781c-.909 0-1.764.631-1.913 1.617c-.34 2.242-.801 8.864 4.425 14.09s11.848 4.764 14.09 4.425c.986-.15 1.617-1.004 1.617-1.913v-4.372a2 2 0 0 0-1.671-1.973l-4.436-.739a2 2 0 0 0-2.118 1.078l-.346.693a5 5 0 0 1-.363-.105c-.62-.206-1.481-.63-2.359-1.508s-1.302-1.739-1.508-2.36a5 5 0 0 1-.125-.447z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCamera: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8.293 4.293A1 1 0 0 1 9 4h6a1 1 0 0 1 .707.293L17.414 6H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2.586zM9.414 6L7.707 7.707A1 1 0 0 1 7 8H4v10h16V8h-3a1 1 0 0 1-.707-.293L14.586 6zM12 10.5a2 2 0 1 0 0 4a2 2 0 0 0 0-4m-4 2a4 4 0 1 1 8 0a4 4 0 0 1-8 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCaretDown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m17 10l-5 6l-5-6z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCaretLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m14 17l-6-5l6-5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCaretRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m10 7l6 5l-6 5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCaretUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m7 14l5-6l5 6z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCheck: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M20.664 5.253a1 1 0 0 1 .083 1.411l-10.666 12a1 1 0 0 1-1.495 0l-5.333-6a1 1 0 0 1 1.494-1.328l4.586 5.159l9.92-11.16a1 1 0 0 1 1.411-.082\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miChevronDoubleDown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5.293 6.293a1 1 0 0 1 1.414 0L12 11.586l5.293-5.293a1 1 0 1 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414m0 6a1 1 0 0 1 1.414 0L12 17.586l5.293-5.293a1 1 0 0 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miChevronDoubleLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17.707 5.293a1 1 0 0 1 0 1.414L12.414 12l5.293 5.293a1 1 0 0 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0m-6 0a1 1 0 0 1 0 1.414L6.414 12l5.293 5.293a1 1 0 0 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miChevronDoubleRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12.293 5.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414L17.586 12l-5.293-5.293a1 1 0 0 1 0-1.414m-6 0a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414L11.586 12L6.293 6.707a1 1 0 0 1 0-1.414\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miChevronDoubleUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11.293 4.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1-1.414 1.414L12 6.414l-5.293 5.293a1 1 0 0 1-1.414-1.414zM12 12.414l-5.293 5.293a1 1 0 0 1-1.414-1.414l6-6a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1-1.414 1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miChevronDown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5.293 9.293a1 1 0 0 1 1.414 0L12 14.586l5.293-5.293a1 1 0 1 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miChevronLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14.707 5.293a1 1 0 0 1 0 1.414L9.414 12l5.293 5.293a1 1 0 0 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miChevronRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.293 18.707a1 1 0 0 1 0-1.414L14.586 12L9.293 6.707a1 1 0 0 1 1.414-1.414l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miChevronUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11.293 7.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1-1.414 1.414L12 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCircle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 4a8 8 0 1 0 0 16a8 8 0 0 0 0-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCircleAdd: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 4a8 8 0 1 0 0 16a8 8 0 0 0 0-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12m10-5a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H8a1 1 0 1 1 0-2h3V8a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCircleArrowDown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 4a8 8 0 1 0 0 16a8 8 0 0 0 0-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12m10-6a1 1 0 0 1 1 1v7.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L11 14.586V7a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCircleArrowLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 4a8 8 0 1 0 0 16a8 8 0 0 0 0-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12m9.707-4.707a1 1 0 0 1 0 1.414L9.414 11H17a1 1 0 1 1 0 2H9.414l2.293 2.293a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCircleArrowRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 4a8 8 0 1 0 0 16a8 8 0 0 0 0-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12m10.293-4.707a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L14.586 13H7a1 1 0 1 1 0-2h7.586l-2.293-2.293a1 1 0 0 1 0-1.414\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCircleArrowUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 4a8 8 0 1 0 0 16a8 8 0 0 0 0-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12m9-2.586l-2.293 2.293a1 1 0 0 1-1.414-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L13 9.414V17a1 1 0 1 1-2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCircleCheck: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 4a8 8 0 1 0 0 16a8 8 0 0 0 0-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12m14.664-3.247a1 1 0 0 1 .083 1.411l-5.333 6a1 1 0 0 1-1.495 0l-2.666-3a1 1 0 0 1 1.494-1.328l1.92 2.159l4.586-5.16a1 1 0 0 1 1.411-.082\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCircleError: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 4a8 8 0 1 0 0 16a8 8 0 0 0 0-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12m5.793-4.207a1 1 0 0 1 1.414 0L12 10.586l2.793-2.793a1 1 0 1 1 1.414 1.414L13.414 12l2.793 2.793a1 1 0 0 1-1.414 1.414L12 13.414l-2.793 2.793a1 1 0 0 1-1.414-1.414L10.586 12L7.793 9.207a1 1 0 0 1 0-1.414\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCircleHelp: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M12 4a8 8 0 1 0 0 16a8 8 0 0 0 0-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12\"/><path d=\"M12 14a1 1 0 0 1-1-1v-1a1 1 0 1 1 2 0v1a1 1 0 0 1-1 1m-1.5 2.5a1.5 1.5 0 1 1 3 0a1.5 1.5 0 0 1-3 0\"/><path d=\"M12.39 7.811c-.957-.045-1.76.49-1.904 1.353a1 1 0 0 1-1.972-.328c.356-2.136 2.303-3.102 3.971-3.022c.854.04 1.733.347 2.409.979C15.587 7.44 16 8.368 16 9.5c0 1.291-.508 2.249-1.383 2.832c-.803.535-1.788.668-2.617.668a1 1 0 1 1 0-2c.67 0 1.186-.117 1.508-.332c.25-.167.492-.46.492-1.168c0-.618-.212-1.003-.472-1.246c-.277-.259-.68-.42-1.138-.443\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCircleInformation: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M12 4a8 8 0 1 0 0 16a8 8 0 0 0 0-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12\"/><path d=\"M12 10a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1m1.5-2.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCircleRemove: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 4a8 8 0 1 0 0 16a8 8 0 0 0 0-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12m5 0a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCircleWarning: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M12 4a8 8 0 1 0 0 16a8 8 0 0 0 0-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12\"/><path d=\"M12 14a1 1 0 0 1-1-1V7a1 1 0 1 1 2 0v6a1 1 0 0 1-1 1m-1.5 2.5a1.5 1.5 0 1 1 3 0a1.5 1.5 0 0 1-3 0\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miClipboard: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1h2a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm0 2H6v15h12V5h-2v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1zm6-1h-4v1h4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miClipboardCheck: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1h2a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm0 2H6v15h12V5h-2v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1zm6-1h-4v1h4zm1.707 6.793a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L11 14.086l3.293-3.293a1 1 0 0 1 1.414 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miClipboardList: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M9 11.5a1 1 0 1 0 0-2a1 1 0 0 0 0 2m2-1a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1m1 2a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 3a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm-2-2a1 1 0 1 1-2 0a1 1 0 0 1 2 0m-1 4a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/><path d=\"M9 2a1 1 0 0 0-1 1H6a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-2a1 1 0 0 0-1-1zm7 3h2v15H6V5h2v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1zm-6 0V4h4v1z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miClock: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 4a8 8 0 1 0 0 16a8 8 0 0 0 0-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12m10-6a1 1 0 0 1 1 1v4.586l2.707 2.707a1 1 0 0 1-1.414 1.414l-3-3A1 1 0 0 1 11 12V7a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miClose: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5.293 5.293a1 1 0 0 1 1.414 0L12 10.586l5.293-5.293a1 1 0 1 1 1.414 1.414L13.414 12l5.293 5.293a1 1 0 0 1-1.414 1.414L12 13.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L10.586 12L5.293 6.707a1 1 0 0 1 0-1.414\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCloud: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 10a6 6 0 0 1 11.671-1.963A6 6 0 0 1 16 20H7a5 5 0 0 1-1.986-9.59A6 6 0 0 1 5 10m6-4a4 4 0 0 0-3.903 4.879a1 1 0 0 1-.757 1.194A3.002 3.002 0 0 0 7 18h9a4 4 0 1 0-.08-8a1 1 0 0 1-1-.8A4 4 0 0 0 11 6\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCloudDownload: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 4a4 4 0 0 0-3.999 4.102a1 1 0 0 1-.75.992A3.002 3.002 0 0 0 7 15h1a1 1 0 1 1 0 2H7a5 5 0 0 1-1.97-9.596a6 6 0 0 1 11.169-2.4A6 6 0 0 1 16 17a1 1 0 1 1 0-2a4 4 0 1 0-.328-7.987a1 1 0 0 1-.999-.6A4 4 0 0 0 11 4m1 6a1 1 0 0 1 1 1v7.586l.293-.293a1 1 0 0 1 1.414 1.414l-2 2a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414l.293.293V11a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCloudUpload: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 4a4 4 0 0 0-3.999 4.102a1 1 0 0 1-.75.992A3.002 3.002 0 0 0 7 15h1a1 1 0 1 1 0 2H7a5 5 0 0 1-1.97-9.596a6 6 0 0 1 11.169-2.4A6 6 0 0 1 16 17a1 1 0 1 1 0-2a4 4 0 1 0-.328-7.987a1 1 0 0 1-.999-.6A4 4 0 0 0 11 4m.293 5.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1-1.414 1.414L13 12.414V20a1 1 0 1 1-2 0v-7.586l-.293.293a1 1 0 0 1-1.414-1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCloudy: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16 5a3 3 0 0 1 2.557 4.57a6 6 0 0 0-1.886-.533a6.02 6.02 0 0 0-2.697-3.25A3 3 0 0 1 16 5m-4.055.074a6 6 0 0 0-6.931 6.336A5 5 0 0 0 7 21h9a6 6 0 0 0 4.2-10.285a5 5 0 0 0-8.255-5.64zM7 11a4 4 0 0 1 7.92-.8a1 1 0 0 0 1 .8H16a4 4 0 0 1 0 8H7a3 3 0 0 1-.66-5.927a1 1 0 0 0 .757-1.194A4 4 0 0 1 7 11\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miComment: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm14 8.586L11.586 19H5V5h14zM14.414 19L19 14.414V19z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCompass: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 12a8 8 0 1 1 16 0a8 8 0 0 1-16 0m8-10C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10S17.523 2 12 2m1.414 11.414l2.122-4.95l-4.95 2.122l-2.122 4.95z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miComputer: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-7v2h3a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h3v-2H4a2 2 0 0 1-2-2zm18 11V5H4v11z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCopy: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4h4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2v-4H4a2 2 0 0 1-2-2zm8 12v4h10V10h-4v4a2 2 0 0 1-2 2zm4-2V4H4v10z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miCreditCard: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M22 6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2zm-2 2H4V6h16zM4 11h16v7H4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miDatabase: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 6c0 .026.01.17.292.42c.28.248.744.518 1.402.765C8.004 7.675 9.88 8 12 8s3.997-.324 5.306-.815c.658-.247 1.121-.517 1.402-.766C18.99 6.17 19 6.026 19 6s-.01-.17-.292-.42c-.28-.248-.744-.518-1.402-.765C15.996 4.325 14.12 4 12 4s-3.997.324-5.306.815c-.658.247-1.121.517-1.402.766C5.01 5.83 5 5.974 5 6M3 6c0-.803.437-1.448.965-1.916c.53-.469 1.238-.846 2.027-1.142C7.578 2.347 9.702 2 12 2s4.422.347 6.008.942c.79.296 1.498.673 2.027 1.142C20.562 4.552 21 5.197 21 6v12c0 .803-.438 1.448-.965 1.916c-.53.469-1.238.846-2.027 1.142c-1.586.595-3.71.942-6.008.942s-4.422-.348-6.008-.942c-.79-.296-1.498-.673-2.027-1.142C3.437 19.448 3 18.803 3 18zm2 4c0 .025.01.17.292.42c.28.248.744.518 1.402.765C8.004 11.675 9.88 12 12 12s3.997-.324 5.306-.815c.658-.247 1.121-.517 1.402-.766c.282-.25.292-.394.292-.419V8.616a9 9 0 0 1-.992.442C16.422 9.653 14.298 10 12 10s-4.422-.347-6.008-.942A9 9 0 0 1 5 8.616zm0 2.616V14c0 .025.01.17.292.42c.28.248.744.518 1.402.765C8.004 15.675 9.88 16 12 16s3.997-.324 5.306-.815c.658-.247 1.121-.517 1.402-.766c.282-.25.292-.394.292-.419v-1.384q-.467.245-.992.442c-1.586.595-3.71.942-6.008.942s-4.422-.348-6.008-.942A9 9 0 0 1 5 12.616m0 4V18c0 .026.01.17.292.42c.28.248.744.518 1.402.765C8.004 19.675 9.88 20 12 20s3.997-.324 5.306-.815c.658-.247 1.121-.517 1.402-.765c.282-.25.292-.395.292-.42v-1.384q-.467.245-.992.442c-1.586.595-3.71.942-6.008.942s-4.422-.348-6.008-.942A9 9 0 0 1 5 16.616\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miDelete: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2h4a1 1 0 1 1 0 2h-1.069l-.867 12.142A2 2 0 0 1 17.069 22H6.93a2 2 0 0 1-1.995-1.858L4.07 8H3a1 1 0 0 1 0-2h4zm2 2h6V4H9zM6.074 8l.857 12H17.07l.857-12zM10 10a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1m4 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miDeleteAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2h4a1 1 0 1 1 0 2h-1.069l-.867 12.142A2 2 0 0 1 17.069 22H6.93a2 2 0 0 1-1.995-1.858L4.07 8H3a1 1 0 0 1 0-2h4zm2 2h6V4H9zM6.074 8l.857 12H17.07l.857-12z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miDocument: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 4a2 2 0 0 1 2-2h8a1 1 0 0 1 .707.293l5 5A1 1 0 0 1 20 8v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm13.586 4L14 4.414V8zM12 4H6v16h12V10h-5a1 1 0 0 1-1-1zm-4 9a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miDocumentAdd: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 4a2 2 0 0 1 2-2h8a1 1 0 0 1 .707.293l5 5A1 1 0 0 1 20 8v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm13.586 4L14 4.414V8zM12 4H6v16h12V10h-5a1 1 0 0 1-1-1zm0 8a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miDocumentCheck: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 4a2 2 0 0 1 2-2h8a1 1 0 0 1 .707.293l5 5A1 1 0 0 1 20 8v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm13.586 4L14 4.414V8zM12 4H6v16h12V10h-5a1 1 0 0 1-1-1zm3.707 8.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L11 15.586l3.293-3.293a1 1 0 0 1 1.414 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miDocumentDownload: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 4a2 2 0 0 1 2-2h8a1 1 0 0 1 .707.293l5 5A1 1 0 0 1 20 8v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm13.586 4L14 4.414V8zM12 4H6v16h12V10h-5a1 1 0 0 1-1-1zm0 7.5a1 1 0 0 1 1 1v2.586l.293-.293a1 1 0 0 1 1.414 1.414l-2 2a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414l.293.293V12.5a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miDocumentEmpty: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 4a2 2 0 0 1 2-2h8a1 1 0 0 1 .707.293l5 5A1 1 0 0 1 20 8v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm13.586 4L14 4.414V8zM12 4H6v16h12V10h-5a1 1 0 0 1-1-1z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miDocumentRemove: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 4a2 2 0 0 1 2-2h8a1 1 0 0 1 .707.293l5 5A1 1 0 0 1 20 8v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm13.586 4L14 4.414V8zM12 4H6v16h12V10h-5a1 1 0 0 1-1-1zM9 15a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miDownload: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 2a1 1 0 0 1 1 1v10.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L11 13.586V3a1 1 0 0 1 1-1M5 17a1 1 0 0 1 1 1v2h12v-2a1 1 0 1 1 2 0v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miDrag: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 6a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miDrop: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M12.65 2.24a1 1 0 0 0-1.301.001l-.089.077a32 32 0 0 0-1.053.982a34 34 0 0 0-2.479 2.69c-.902 1.094-1.823 2.373-2.522 3.722C4.511 11.052 4 12.528 4 14a8 8 0 1 0 16 0c0-1.472-.511-2.948-1.206-4.288c-.7-1.35-1.62-2.628-2.522-3.723a34 34 0 0 0-3.299-3.462l-.322-.286zM6 14c0-1.028.364-2.177.981-3.368c.614-1.182 1.443-2.341 2.29-3.371A32 32 0 0 1 12 4.35a32 32 0 0 1 2.728 2.909c.848 1.03 1.677 2.19 2.29 3.372c.618 1.191.982 2.34.982 3.368a6 6 0 0 1-12 0z\"/><path d=\"M8.36 14.042a1 1 0 0 0-.674 1.243a4.51 4.51 0 0 0 3.029 3.029a1 1 0 1 0 .57-1.917a2.51 2.51 0 0 1-1.682-1.682a1 1 0 0 0-1.243-.673\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miEdit: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16.293 2.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-13 13A1 1 0 0 1 8 21H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 .293-.707l10-10zM14 7.414l-9 9V19h2.586l9-9zm4 1.172L19.586 7L17 4.414L15.414 6z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miEditAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16.293 3.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-9 9A1 1 0 0 1 11 17H8a1 1 0 0 1-1-1v-3a1 1 0 0 1 .293-.707zM9 13.414V15h1.586l8-8L17 5.414zM3 7a2 2 0 0 1 2-2h5a1 1 0 1 1 0 2H5v12h12v-5a1 1 0 1 1 2 0v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miEmail: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm3.519 0L12 11.671L18.481 6zM20 7.329l-7.341 6.424a1 1 0 0 1-1.318 0L4 7.329V18h16z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miEnter: Icon = {
  "body": "<g fill=\"currentColor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path d=\"M3 14a1 1 0 0 1 1-1h12a3 3 0 0 0 3-3V6a1 1 0 1 1 2 0v4a5 5 0 0 1-5 5H4a1 1 0 0 1-1-1\"/><path d=\"M3.293 14.707a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 1.414L5.414 14l3.293 3.293a1 1 0 1 1-1.414 1.414z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miExpand: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 2a1 1 0 1 0 0 2h1.586l-4.293 4.293a1 1 0 0 0 1.414 1.414L20 5.414V7a1 1 0 1 0 2 0V3a1 1 0 0 0-1-1zM4 18.586V17a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2H5.414l4.293-4.293a1 1 0 0 0-1.414-1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miExport: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11.293 2.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L13 5.414V16a1 1 0 1 1-2 0V5.414L8.707 7.707a1 1 0 0 1-1.414-1.414zM5 17a1 1 0 0 1 1 1v2h12v-2a1 1 0 1 1 2 0v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miExternalLink: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14 5a1 1 0 1 1 0-2h6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V6.414l-9.293 9.293a1 1 0 0 1-1.414-1.414L17.586 5zM3 7a2 2 0 0 1 2-2h5a1 1 0 1 1 0 2H5v12h12v-5a1 1 0 1 1 2 0v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miEye: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0\"/><path d=\"M21.894 11.553C19.736 7.236 15.904 5 12 5s-7.736 2.236-9.894 6.553a1 1 0 0 0 0 .894C4.264 16.764 8.096 19 12 19s7.736-2.236 9.894-6.553a1 1 0 0 0 0-.894M12 17c-2.969 0-6.002-1.62-7.87-5C5.998 8.62 9.03 7 12 7s6.002 1.62 7.87 5c-1.868 3.38-4.901 5-7.87 5\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miEyeOff: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4.707 3.293a1 1 0 0 0-1.414 1.414l2.424 2.424c-1.43 1.076-2.678 2.554-3.611 4.422a1 1 0 0 0 0 .894C4.264 16.764 8.096 19 12 19c1.555 0 3.1-.355 4.53-1.055l2.763 2.762a1 1 0 0 0 1.414-1.414zm10.307 13.135c-.98.383-2 .572-3.014.572c-2.969 0-6.002-1.62-7.87-5c.817-1.479 1.858-2.62 3.018-3.437l2.144 2.144a3 3 0 0 0 4.001 4.001zm3.538-2.532c.483-.556.926-1.187 1.318-1.896c-1.868-3.38-4.9-5-7.87-5q-.168 0-.336.007L9.879 5.223A10.2 10.2 0 0 1 12 5c3.903 0 7.736 2.236 9.894 6.553a1 1 0 0 1 0 .894a13 13 0 0 1-1.925 2.865z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miFavorite: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 2.5a1 1 0 0 1 .894.553l2.58 5.158l5.67.824a1 1 0 0 1 .554 1.706l-4.127 4.024l.928 5.674a1 1 0 0 1-1.455 1.044L12 18.807l-5.044 2.676a1 1 0 0 1-1.455-1.044l.928-5.674l-4.127-4.024a1 1 0 0 1 .554-1.706l5.67-.824l2.58-5.158A1 1 0 0 1 12 2.5m0 3.236l-1.918 3.836a1 1 0 0 1-.75.543l-4.184.608l3.05 2.973a1 1 0 0 1 .289.878L7.8 18.771l3.731-1.98a1 1 0 0 1 .938 0l3.731 1.98l-.687-4.197a1 1 0 0 1 .289-.877l3.05-2.974l-4.183-.608a1 1 0 0 1-.75-.543z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miFilter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 5a1 1 0 1 0 0 2a1 1 0 0 0 0-2M6.17 5a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 0 1 0-2zM15 11a1 1 0 1 0 0 2a1 1 0 0 0 0-2m-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2zM9 17a1 1 0 1 0 0 2a1 1 0 0 0 0-2m-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miFilter1: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 7a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m2 5a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1m2 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miFilterAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 7a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m2 5a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1m2 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miFlag: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5 4.797c1.517-.312 2.67-.33 3.626-.211c1.119.14 2.018.473 3.023.85l.03.012c.987.37 2.08.78 3.447.95c1.104.139 2.355.118 3.874-.158v8.963c-1.517.312-2.67.33-3.626.211c-1.119-.14-2.018-.473-3.023-.85l-.03-.012c-.987-.37-2.08-.78-3.447-.95c-1.104-.139-2.355-.118-3.874.158zm14.758-.767c-1.9.475-3.275.523-4.384.384c-1.119-.14-2.018-.473-3.023-.85l-.03-.012c-.987-.37-2.08-.78-3.447-.95c-1.387-.174-3.006-.098-5.096.423A1 1 0 0 0 3 4v17a1 1 0 1 0 2 0v-5.203c1.517-.312 2.67-.33 3.626-.211c1.119.14 2.018.473 3.023.85l.03.012c.987.37 2.08.78 3.447.95c1.391.174 3.017.097 5.117-.428A1 1 0 0 0 21 16V5a1 1 0 0 0-1.242-.97\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miFog: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 6a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1m-9 4a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m3 3a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2zm12 0a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm0-4a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zM7 18a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m-4-1a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zM5 5a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miFolder: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 6a2 2 0 0 1 2-2h5a1 1 0 0 1 .707.293L11.414 6H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm6.586 0H4v12h16V8h-9a1 1 0 0 1-.707-.293z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miFolderAdd: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 6a2 2 0 0 1 2-2h5a1 1 0 0 1 .707.293L11.414 6H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm6.586 0H4v12h16V8h-9a1 1 0 0 1-.707-.293zM12 10a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miFolderCheck: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 6a2 2 0 0 1 2-2h5a1 1 0 0 1 .707.293L11.414 6H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm6.586 0H4v12h16V8h-9a1 1 0 0 1-.707-.293zm7.121 4.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L11 13.586l3.293-3.293a1 1 0 0 1 1.414 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miFolderDownload: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 6a2 2 0 0 1 2-2h5a1 1 0 0 1 .707.293L11.414 6H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm6.586 0H4v12h16V8h-9a1 1 0 0 1-.707-.293zM12 9.5a1 1 0 0 1 1 1v2.586l.293-.293a1 1 0 0 1 1.414 1.414l-2 2a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414l.293.293V10.5a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miFolderRemove: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 6a2 2 0 0 1 2-2h5a1 1 0 0 1 .707.293L11.414 6H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm6.586 0H4v12h16V8h-9a1 1 0 0 1-.707-.293zM9 13a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miGrid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm6 0H5v4h4zm4 0a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2zm6 0h-4v4h4zM3 15a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm6 0H5v4h4zm4 0a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2zm6 0h-4v4h4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miHeart: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 4.528a6 6 0 0 0-8.243 8.715l6.829 6.828a2 2 0 0 0 2.828 0l6.829-6.828A6 6 0 0 0 12 4.528m-1.172 1.644l.465.464a1 1 0 0 0 1.414 0l.465-.464a4 4 0 1 1 5.656 5.656L12 18.657l-6.828-6.829a4 4 0 0 1 5.656-5.656\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miHome: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11.336 2.253a1 1 0 0 1 1.328 0l9 8a1 1 0 0 1-1.328 1.494L20 11.45V19a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7.55l-.336.297a1 1 0 0 1-1.328-1.494zM6 9.67V19h3v-5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v5h3V9.671l-6-5.333zM13 19v-4h-2v4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miImage: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M15.5 10a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3\"/><path d=\"M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm16 0H5v7.92l3.375-2.7a1 1 0 0 1 1.25 0l4.3 3.44l1.368-1.367a1 1 0 0 1 1.414 0L19 14.586zM5 19h14v-1.586l-3-3l-1.293 1.293a1 1 0 0 1-1.332.074L9 12.28l-4 3.2z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miInbox: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2 9v5h14v-5h-2.28l-.771 2.316A1 1 0 0 1 15 17H9a1 1 0 0 1-.949-.684L7.28 14zm14-2V5H5v7h2.28a2 2 0 0 1 1.897 1.367L9.72 15h4.558l.544-1.633A2 2 0 0 1 16.721 12z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miItalic: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14.021 4H19a1 1 0 1 1 0 2h-4.246l-3.428 12H15a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2h4.246l3.428-12H9a1 1 0 0 1 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miLaptop: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm18 0H4v11h16zm2 15a1 1 0 0 1-1 1H3a1 1 0 1 1 0-2h18a1 1 0 0 1 1 1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miLayers: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M11.514 2.126a1 1 0 0 1 .972 0l9 5a1 1 0 0 1 0 1.748l-9 5a1 1 0 0 1-.972 0l-9-5a1 1 0 0 1 0-1.748zM5.06 8L12 11.856L18.94 8L12 4.144z\"/><path d=\"M2.126 11.514a1 1 0 0 1 1.36-.388L12 15.856l8.514-4.73a1 1 0 0 1 .972 1.748l-9 5a1 1 0 0 1-.972 0l-9-5a1 1 0 0 1-.388-1.36\"/><path d=\"M2.126 15.514a1 1 0 0 1 1.36-.388L12 19.856l8.514-4.73a1 1 0 0 1 .972 1.748l-9 5a1 1 0 0 1-.972 0l-9-5a1 1 0 0 1-.388-1.36\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miLayout: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3.987A2 2 0 0 1 2 19zm2 4h16V5H4zm4 2H4v8h4zm2 8h10v-8H10z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miLink: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 8c-2.248 0-4 1.752-4 4s1.752 4 4 4h2a1 1 0 1 1 0 2H8c-3.352 0-6-2.648-6-6s2.648-6 6-6h2a1 1 0 1 1 0 2zm5-1a1 1 0 0 1 1-1h2c3.352 0 6 2.648 6 6s-2.648 6-6 6h-2a1 1 0 1 1 0-2h2c2.248 0 4-1.752 4-4s-1.752-4-4-4h-2a1 1 0 0 1-1-1m-6 5a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miLinkAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16.2 6a1 1 0 0 1 1-1c.637 0 1.262.128 1.871.372c.663.265 1.173.658 1.636 1.12c.463.464.856.974 1.121 1.637c.244.609.372 1.234.372 1.871s-.128 1.262-.372 1.871c-.261.655-.648 1.16-1.104 1.619l-.984 1.083l-.033.034l-3.2 3.2c-.463.463-.973.856-1.636 1.122A5 5 0 0 1 13 19.3a5 5 0 0 1-1.871-.372c-.663-.265-1.173-.658-1.636-1.12c-.463-.464-.856-.974-1.121-1.637A5.2 5.2 0 0 1 8 14.2c0-.637.128-1.262.372-1.871c.265-.663.658-1.173 1.12-1.636l1.1-1.1a1 1 0 1 1 1.415 1.414l-1.1 1.1c-.337.337-.544.627-.678.964A3 3 0 0 0 10 14.2c0 .476.077.85.229 1.229c.134.337.341.627.678.964s.627.544.964.678c.391.157.766.229 1.129.229s.738-.072 1.129-.229c.337-.134.627-.341.964-.678l3.183-3.183l.984-1.083l.033-.034c.337-.337.544-.627.678-.964c.157-.391.229-.766.229-1.129s-.072-.738-.229-1.129c-.134-.337-.341-.627-.678-.964s-.627-.544-.964-.679A3 3 0 0 0 17.2 7a1 1 0 0 1-1-1m-4.9 1.5c-.363 0-.738.072-1.129.228c-.337.135-.627.342-.964.68L5.924 11.69l-.984 1.083l-.033.034c-.337.337-.544.627-.679.964A3 3 0 0 0 4 14.9c0 .363.072.738.228 1.129c.135.337.342.627.68.964c.336.337.626.544.963.679c.391.156.766.228 1.129.228a1 1 0 1 1 0 2a5 5 0 0 1-1.871-.371c-.663-.266-1.173-.659-1.636-1.122s-.856-.973-1.121-1.636A5 5 0 0 1 2 14.9c0-.637.128-1.262.372-1.871c.261-.655.648-1.16 1.104-1.619l.984-1.083l.033-.034l3.3-3.3c.463-.463.973-.856 1.636-1.121A5 5 0 0 1 11.3 5.5c.637 0 1.262.128 1.871.372c.663.265 1.173.658 1.636 1.12c.463.464.856.974 1.121 1.637c.244.609.372 1.234.372 1.871s-.128 1.262-.372 1.871c-.262.655-.649 1.162-1.105 1.62l-1.086 1.185a1 1 0 0 1-1.474-1.352l1.1-1.2l.03-.031c.337-.337.544-.627.678-.964c.157-.391.229-.766.229-1.129s-.072-.738-.229-1.129c-.134-.337-.341-.627-.678-.964s-.627-.544-.964-.679A3 3 0 0 0 11.3 7.5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miList: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 7a1 1 0 0 1 1-1h1a1 1 0 0 1 0 2H5a1 1 0 0 1-1-1m5 0a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1m-5 5a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m5 0a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1m-5 5a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m5 0a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miLocation: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 2c-4.4 0-8 3.6-8 8c0 5.4 7 11.5 7.3 11.8c.2.1.5.2.7.2s.5-.1.7-.2C13 21.5 20 15.4 20 10c0-4.4-3.6-8-8-8m0 17.7c-2.1-2-6-6.3-6-9.7c0-3.3 2.7-6 6-6s6 2.7 6 6s-3.9 7.7-6 9.7M12 6c-2.2 0-4 1.8-4 4s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m0 6c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miLock: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 4c1.648 0 3 1.352 3 3v3H9V7c0-1.648 1.352-3 3-3m5 6V7c0-2.752-2.248-5-5-5S7 4.248 7 7v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zM6 12h12v8H6z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miLogIn: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M14 19a1 1 0 1 0 0 2h5a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-5a1 1 0 1 0 0 2h5v14z\"/><path d=\"M15.714 12.7a1 1 0 0 0 .286-.697v-.006a1 1 0 0 0-.293-.704l-4-4a1 1 0 1 0-1.414 1.414L12.586 11H3a1 1 0 1 0 0 2h9.586l-2.293 2.293a1 1 0 1 0 1.414 1.414l4-4z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miLogOut: Icon = {
  "body": "<g fill=\"currentColor\"><path fill-rule=\"evenodd\" d=\"M11 20a1 1 0 0 0-1-1H5V5h5a1 1 0 1 0 0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h5a1 1 0 0 0 1-1\" clip-rule=\"evenodd\"/><path d=\"M21.714 12.7a1 1 0 0 0 .286-.697v-.006a1 1 0 0 0-.293-.704l-4-4a1 1 0 1 0-1.414 1.414L18.586 11H9a1 1 0 1 0 0 2h9.586l-2.293 2.293a1 1 0 0 0 1.414 1.414l4-4z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miMap: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8.684 3.051a1 1 0 0 1 .632 0L15 4.946l4.367-1.456A2 2 0 0 1 22 5.387V17.28a2 2 0 0 1-1.367 1.898l-5.317 1.772a1 1 0 0 1-.632 0L9 19.054L4.632 20.51A2 2 0 0 1 2 18.613V6.72a2 2 0 0 1 1.368-1.898L8.684 3.05zM10 17.28l4 1.334V6.72l-4-1.334zM8 5.387L4 6.721v11.892l4-1.334zm8 1.334v11.892l4-1.334V5.387z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miMegaphone: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17.502 2.135A1 1 0 0 1 18 3v4a4 4 0 0 1 2.981 1.333A4 4 0 0 1 22 11c0 1.024-.386 1.96-1.019 2.667A4 4 0 0 1 18 15v4a1 1 0 0 1-1.496.868L10 16.152V21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h5.734l6.77-3.868a1 1 0 0 1 .998.003M10 14a1 1 0 0 1 .496.132L16 17.277V4.723l-5.504 3.145A1 1 0 0 1 10 8H4v6zm-4 2v4h2v-4zm12-3c.592 0 1.123-.256 1.491-.667c.317-.354.509-.82.509-1.333s-.192-.979-.509-1.333A2 2 0 0 0 18 9z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miMenu: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 7a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m0 5a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m0 5a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miMessage: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-4.586l-2.707 2.707a1 1 0 0 1-1.414 0L8.586 19H4a2 2 0 0 1-2-2zm18 0H4v11h5a1 1 0 0 1 .707.293L12 19.586l2.293-2.293A1 1 0 0 1 15 17h5zM6 9.5a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miMessageAlt: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-4.586l-2.707 2.707a1 1 0 0 1-1.414 0L8.586 19H4a2 2 0 0 1-2-2zm18 0H4v11h5a1 1 0 0 1 .707.293L12 19.586l2.293-2.293A1 1 0 0 1 15 17h5z\"/><path d=\"M13.5 11.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m4 0a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m-8 0a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miMinimize: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M21.707 3.707a1 1 0 0 0-1.414-1.414L16 6.586V5a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2h-1.586zm-19.414 18a1 1 0 0 1 0-1.414L6.586 16H5a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-1.586l-4.293 4.293a1 1 0 0 1-1.414 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miMobile: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M6 5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2zm10 0H8v14h8z\"/><path d=\"M13 17a1 1 0 1 1-2 0a1 1 0 0 1 2 0\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miMoon: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.36 3.293a1 1 0 0 1 .187 1.157A7.45 7.45 0 0 0 19.55 14.453a1 1 0 0 1 1.343 1.343a9.45 9.45 0 1 1-12.69-12.69a1 1 0 0 1 1.158.187zM6.823 6.67A7.45 7.45 0 0 0 17.33 17.179A9.45 9.45 0 0 1 6.821 6.67z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miNext: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 7.766c0-1.554 1.696-2.515 3.029-1.715l7.056 4.234c1.295.777 1.295 2.653 0 3.43L8.03 17.949c-1.333.8-3.029-.16-3.029-1.715zM14.056 12L7 7.766v8.468zM18 6a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miNotification: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.146 3.248a2 2 0 0 1 3.708 0A7 7 0 0 1 19 10v4.697l1.832 2.748A1 1 0 0 1 20 19h-4.535a3.501 3.501 0 0 1-6.93 0H4a1 1 0 0 1-.832-1.555L5 14.697V10c0-3.224 2.18-5.94 5.146-6.752M10.586 19a1.5 1.5 0 0 0 2.829 0zM12 5a5 5 0 0 0-5 5v5a1 1 0 0 1-.168.555L5.869 17H18.13l-.963-1.445A1 1 0 0 1 17 15v-5a5 5 0 0 0-5-5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miNotificationOff: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19 10c0-3.224-2.18-5.94-5.146-6.752a2 2 0 0 0-3.708 0a7 7 0 0 0-1.587.655l1.492 1.491A5 5 0 0 1 17 10v2.343l2 2zM3.175 17.434L5 14.697V10c0-1.05.231-2.046.646-2.94L3.293 4.707a1 1 0 1 1 1.414-1.414l16 16a1 1 0 0 1-1.414 1.414L17.586 19h-2.121a3.5 3.5 0 0 1-6.93 0H4.013a1 1 0 0 1-.633-.215a1 1 0 0 1-.205-1.35zM5.87 17h9.717l-8.39-8.39A5 5 0 0 0 7 10v5a1 1 0 0 1-.168.555zm4.716 2a1.5 1.5 0 0 0 2.83 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miOptionsHorizontal: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 14a2 2 0 1 0 0-4a2 2 0 0 0 0 4m-6 0a2 2 0 1 0 0-4a2 2 0 0 0 0 4m12 0a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miOptionsVertical: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 12a2 2 0 1 0 4 0a2 2 0 0 0-4 0m0-6a2 2 0 1 0 4 0a2 2 0 0 0-4 0m0 12a2 2 0 1 0 4 0a2 2 0 0 0-4 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miPause: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 6a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1m6 0a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miPen: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17.707 2.293a1 1 0 0 0-1.414 0L14 4.586l-1.293-1.293a1 1 0 0 0-1.414 0l-6 6a1 1 0 0 0 1.414 1.414L12 5.414l.586.586l-2.293 2.293l-7 7A1 1 0 0 0 3 16v4a1 1 0 0 0 1 1h4a1 1 0 0 0 .707-.293l7-7l6-6a1 1 0 0 0 0-1.414zm-3 4.414L17 4.414L19.586 7L15 11.586L12.414 9zM5 16.414l6-6L13.586 13l-6 6H5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miPercentage: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18.707 5.293a1 1 0 0 1 0 1.414l-12 12a1 1 0 0 1-1.414-1.414l12-12a1 1 0 0 1 1.414 0M17 19a2 2 0 1 0 0-4a2 2 0 0 0 0 4M7 9a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miPin: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 10.6V4a1 1 0 0 1 0-2h12a1 1 0 1 1 0 2v6.6c.932 1.02 1.432 2.034 1.699 2.834c.146.438.22.81.26 1.08a4 4 0 0 1 .04.43v.034l.001.013v.008s-.005-.131 0 .001a1 1 0 0 1-1 1h-6v5a1 1 0 1 1-2 0v-5H5a1 1 0 0 1-1-1v-.022a2 2 0 0 1 .006-.134a5 5 0 0 1 .035-.33c.04-.27.114-.642.26-1.08c.267-.8.767-1.814 1.699-2.835zM16 4H8v7a1 1 0 0 1-.293.707c-.847.847-1.271 1.678-1.486 2.293H17.78c-.215-.615-.64-1.446-1.486-2.293A1 1 0 0 1 16 11z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miPlay: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 6.741c0-1.544 1.674-2.505 3.008-1.728l9.015 5.26c1.323.771 1.323 2.683 0 3.455l-9.015 5.258C7.674 19.764 6 18.803 6 17.26zM17.015 12L8 6.741V17.26z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miPrevious: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19 7.766c0-1.554-1.696-2.515-3.029-1.715l-7.056 4.234c-1.295.777-1.295 2.653 0 3.43l7.056 4.234c1.333.8 3.029-.16 3.029-1.715zM9.944 12L17 7.766v8.468zM6 6a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miPrint: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 2a1 1 0 0 0-1 1v4H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2v2a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-2h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2V3a1 1 0 0 0-1-1zm10 12H7a1 1 0 0 0-1 1v2H4V9h16v8h-2v-2a1 1 0 0 0-1-1m-1-7H8V4h8zM5 10v2h3v-2zm11 6v4H8v-4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miRain: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 2a6 6 0 0 0-5.986 6.41a5 5 0 0 0-1.322 8.34a1 1 0 1 0 1.324-1.5a3.002 3.002 0 0 1 1.324-5.178a1 1 0 0 0 .757-1.193A4 4 0 1 1 14.92 7.2a1 1 0 0 0 .999.8H16a4 4 0 0 1 2.4 7.2a1 1 0 0 0 1.201 1.6a6 6 0 0 0-2.93-10.762A6 6 0 0 0 11 2m1.949 13.316a1 1 0 0 0-1.898-.632l-2 6a1 1 0 0 0 1.898.632zm3.367-2.265a1 1 0 0 1 .633 1.265l-2 6a1 1 0 0 1-1.898-.632l2-6a1 1 0 0 1 1.265-.633M9.45 14.316a1 1 0 0 0-1.898-.632l-2 6a1 1 0 0 0 1.898.632z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miRefresh: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12.793 2.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L14.086 7H12.5C8.952 7 6 9.952 6 13.5S8.952 20 12.5 20s6.5-2.952 6.5-6.5a1 1 0 1 1 2 0c0 4.652-3.848 8.5-8.5 8.5S4 18.152 4 13.5S7.848 5 12.5 5h1.586l-1.293-1.293a1 1 0 0 1 0-1.414\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miRemove: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 12a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miReorder: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 6a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miReorderAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8.5 7a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0 7a2 2 0 1 0 0-4a2 2 0 0 0 0 4m2 5a2 2 0 1 1-4 0a2 2 0 0 1 4 0m5-12a2 2 0 1 0 0-4a2 2 0 0 0 0 4m2 5a2 2 0 1 1-4 0a2 2 0 0 1 4 0m-2 9a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miRepeat: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M20.924 5.617a1 1 0 0 0-.217-.324l-3-3a1 1 0 1 0-1.414 1.414L17.586 5H8a5 5 0 0 0-5 5v2a1 1 0 1 0 2 0v-2a3 3 0 0 1 3-3h9.586l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3A1 1 0 0 0 21 6m-.076-.383a1 1 0 0 1 .076.38zm-17.848 12a1 1 0 0 0 .217 1.09l3 3a1 1 0 0 0 1.414-1.414L6.414 19H16a5 5 0 0 0 5-5v-2a1 1 0 1 0-2 0v2a3 3 0 0 1-3 3H6.414l1.293-1.293a1 1 0 1 0-1.414-1.414l-3 3m-.217.324a1 1 0 0 1 .215-.322z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miSave: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 5a2 2 0 0 1 2-2h11.586A2 2 0 0 1 18 3.586l2.707 2.707A1 1 0 0 1 21 7v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm6 14h6v-6H9zm8 0h2V7.414l-2-2V7a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V5H5v14h2v-6a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2zM9 5v2h6V5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miSearch: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 4a6 6 0 1 0 0 12a6 6 0 0 0 0-12m-8 6a8 8 0 1 1 14.32 4.906l5.387 5.387a1 1 0 0 1-1.414 1.414l-5.387-5.387A8 8 0 0 1 2 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miSelect: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 4a1 1 0 0 1 .707.293l4 4a1 1 0 0 1-1.414 1.414L12 6.414L8.707 9.707a1 1 0 0 1-1.414-1.414l4-4A1 1 0 0 1 12 4M7.293 14.293a1 1 0 0 1 1.414 0L12 17.586l3.293-3.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miSend: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 2a1 1 0 0 1 .894.553l9 18a1 1 0 0 1-1.11 1.423L12 20.024l-8.783 1.952a1 1 0 0 1-1.111-1.423l9-18A1 1 0 0 1 12 2m1 16.198l6.166 1.37L13 7.236zM11 7.236L4.834 19.568L11 18.198z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miSettings: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M12 4a1 1 0 0 0-1 1c0 1.692-2.046 2.54-3.243 1.343a1 1 0 1 0-1.414 1.414C7.54 8.954 6.693 11 5 11a1 1 0 1 0 0 2c1.692 0 2.54 2.046 1.343 3.243a1 1 0 0 0 1.414 1.414C8.954 16.46 11 17.307 11 19a1 1 0 1 0 2 0c0-1.692 2.046-2.54 3.243-1.343a1 1 0 1 0 1.414-1.414C16.46 15.046 17.307 13 19 13a1 1 0 1 0 0-2c-1.692 0-2.54-2.046-1.343-3.243a1 1 0 0 0-1.414-1.414C15.046 7.54 13 6.693 13 5a1 1 0 0 0-1-1m-2.992.777a3 3 0 0 1 5.984 0a3 3 0 0 1 4.23 4.231a3 3 0 0 1 .001 5.984a3 3 0 0 1-4.231 4.23a3 3 0 0 1-5.984 0a3 3 0 0 1-4.231-4.23a3 3 0 0 1 0-5.984a3 3 0 0 1 4.231-4.231\"/><path d=\"M12 10a2 2 0 1 0 0 4a2 2 0 0 0 0-4m-2.828-.828a4 4 0 1 1 5.656 5.656a4 4 0 0 1-5.656-5.656\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miShare: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11.293 2.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.414L13 5.414V15a1 1 0 1 1-2 0V5.414L9.707 6.707a1 1 0 0 1-1.414-1.414zM4 11a2 2 0 0 1 2-2h2a1 1 0 0 1 0 2H6v9h12v-9h-2a1 1 0 1 1 0-2h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miShoppingCart: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4.142 4L6.01 16.136A1 1 0 0 0 7.016 17H18a1 1 0 0 0 .958-.713l3-10A1 1 0 0 0 21 5H6.32l-.33-2.138a1 1 0 0 0-.346-.627A1 1 0 0 0 4.984 2H3a1 1 0 1 0 0 2zm3.716 11l-1.23-8h13.028l-2.4 8zM10 20a2 2 0 1 1-4 0a2 2 0 0 1 4 0m9 0a2 2 0 1 1-4 0a2 2 0 0 1 4 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miShoppingCartAdd: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6.01 16.136L4.141 4H3a1 1 0 0 1 0-2h1.985a1 1 0 0 1 .66.235a1 1 0 0 1 .346.627L6.319 5H14v2H6.627l1.23 8h9.399l1.5-5h2.088l-1.886 6.287A1 1 0 0 1 18 17H7.016a1 1 0 0 1-.675-.248a1 1 0 0 1-.332-.616zM10 20a2 2 0 1 1-4 0a2 2 0 0 1 4 0m9 0a2 2 0 1 1-4 0a2 2 0 0 1 4 0m0-18a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0V6h-1a1 1 0 1 1 0-2h1V3a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miShuffle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M21.924 6.617a1 1 0 0 0-.217-.324l-3-3a1 1 0 1 0-1.414 1.414L18.586 6h-3.321a5 5 0 0 0-4.288 2.428l-3.67 6.115A3 3 0 0 1 4.736 16H3a1 1 0 1 0 0 2h1.735a5 5 0 0 0 4.288-2.428l3.67-6.115A3 3 0 0 1 15.264 8h3.32l-1.292 1.293a1 1 0 0 0 1.414 1.414l3-3A1 1 0 0 0 22 7m-.076-.383a1 1 0 0 1 .076.38z\"/><path d=\"m21.706 17.708l-2.999 3a1 1 0 0 1-1.414-1.415L18.586 18h-3.321a5 5 0 0 1-4.288-2.428l-3.67-6.115A3 3 0 0 0 4.736 8H3a1 1 0 0 1 0-2h1.735a5 5 0 0 1 4.288 2.428l3.67 6.115A3 3 0 0 0 15.264 16h3.32l-1.292-1.293a1 1 0 0 1 1.414-1.414l3 3c.195.194.292.45.293.704V17a1 1 0 0 1-.294.708z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miSnow: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 2a6 6 0 0 0-5.986 6.41a5 5 0 0 0-1.322 8.34a1 1 0 1 0 1.324-1.5a3.002 3.002 0 0 1 1.324-5.178a1 1 0 0 0 .757-1.193A4 4 0 1 1 14.92 7.2a1 1 0 0 0 .999.8H16a4 4 0 0 1 2.4 7.2a1 1 0 0 0 1.201 1.6a6 6 0 0 0-2.93-10.762A6 6 0 0 0 11 2m3.5 15a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m-3.5-.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m4 3a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m-5 1a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miSnowflake: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13 3a1 1 0 1 0-2 0v2.586l-1.95-1.95A1 1 0 1 0 7.636 5.05L11 8.414V11H8.414L5.05 7.636A1 1 0 1 0 3.636 9.05L5.586 11H3a1 1 0 1 0 0 2h2.586l-1.95 1.95a1 1 0 1 0 1.414 1.414L8.414 13H11v2.586L7.636 18.95a1 1 0 1 0 1.414 1.414l1.95-1.95V21a1 1 0 1 0 2 0v-2.586l1.95 1.95a1 1 0 1 0 1.414-1.414L13 15.586V13h2.586l3.364 3.364a1 1 0 1 0 1.414-1.414L18.414 13H21a1 1 0 1 0 0-2h-2.586l1.95-1.95a1 1 0 1 0-1.414-1.414L15.586 11H13V8.414l3.364-3.364a1 1 0 0 0-1.414-1.414L13 5.586z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miSort: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6.293 4.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L8 7.414V19a1 1 0 1 1-2 0V7.414L3.707 9.707a1 1 0 0 1-1.414-1.414zM16 16.586V5a1 1 0 1 1 2 0v11.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miSpeakers: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M4 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm14 0H6v16h12z\"/><path d=\"M12 12a2 2 0 1 0 0 4a2 2 0 0 0 0-4m-4 2a4 4 0 1 1 8 0a4 4 0 0 1-8 0m5.5-6.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miStop: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2zm12 0H7v10h10z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miStorm: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 2a6 6 0 0 0-5.986 6.41a5 5 0 0 0 .737 9.432a1 1 0 1 0 .498-1.936a3.002 3.002 0 0 1 .09-5.833a1 1 0 0 0 .758-1.194A4 4 0 1 1 14.92 7.2a1 1 0 0 0 .999.8H16a4 4 0 0 1 1.6 7.668a1 1 0 1 0 .8 1.832a6.001 6.001 0 0 0-1.729-11.463A6 6 0 0 0 11 2m1.894 11.447a1 1 0 1 0-1.788-.894l-2 4A1 1 0 0 0 10 18h2.382l-1.276 2.553a1 1 0 1 0 1.788.894l2-4A1 1 0 0 0 14 16h-2.382z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miStrikethrough: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 5C9.571 5 8 6.54 8 8c0 .804.28 1.362.865 1.818c.631.492 1.665.897 3.224 1.182H19a1 1 0 1 1 0 2h-2.189c.788.794 1.189 1.803 1.189 3c0 2.958-2.906 5-6 5c-1.998 0-3.827-.814-4.936-2.149a1 1 0 1 1 1.538-1.278C9.285 18.393 10.52 19 12 19c2.429 0 4-1.54 4-3c0-.804-.28-1.362-.865-1.818c-.631-.492-1.665-.897-3.224-1.182H5a1 1 0 1 1 0-2h2.189C6.401 10.206 6 9.197 6 8c0-2.958 2.906-5 6-5c1.477 0 2.852.444 3.915 1.205a1 1 0 0 1-1.164 1.627C14.046 5.327 13.084 5 12 5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miSun: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 2a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1m7.071 2.929a1 1 0 0 1 0 1.414l-.707.707a1 1 0 1 1-1.414-1.414l.707-.707a1 1 0 0 1 1.414 0m-14.142 0a1 1 0 0 1 1.414 0l.707.707A1 1 0 0 1 5.636 7.05l-.707-.707a1 1 0 0 1 0-1.414M12 8a4 4 0 1 0 0 8a4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0a6 6 0 0 1-12 0m-4 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m17 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1M5.636 16.95a1 1 0 0 1 1.414 1.414l-.707.707a1 1 0 0 1-1.414-1.414zm11.314 1.414a1 1 0 0 1 1.414-1.414l.707.707a1 1 0 0 1-1.414 1.414zM12 19a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miSunrise: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.707 2.293a1 1 0 0 0-1.414 0l-2 2a1 1 0 0 0 1.414 1.414L11 5.414v2.729c0 .473.448.857 1 .857s1-.384 1-.857V5.414l.293.293a1 1 0 1 0 1.414-1.414zM5.636 11.05A1 1 0 0 0 7.05 9.636l-.707-.707a1 1 0 0 0-1.414 1.414zm13.435-.707l-.707.707a1 1 0 0 1-1.414-1.414l.707-.707a1 1 0 0 1 1.414 1.414M8 16a4 4 0 1 1 6.646 3H9.354A4 4 0 0 1 8 16m.97 5H21a1 1 0 1 0 0-2h-3.803a6 6 0 1 0-10.394 0H3a1 1 0 1 0 0 2zM4 17a1 1 0 1 0 0-2H3a1 1 0 1 0 0 2zm18-1a1 1 0 0 1-1 1h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miSunriseAlt: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M13 5a1 1 0 1 0-2 0v1a1 1 0 1 0 2 0zM9.028 19H3a1 1 0 1 1 0-2h3.803a6 6 0 1 1 10.394 0H21a1 1 0 1 1 0 2zM12 10a4 4 0 0 0-2.646 7h5.292A4 4 0 0 0 12 10m7.071-1.657l-.707.707a1 1 0 1 1-1.414-1.414l.707-.707a1 1 0 1 1 1.414 1.414\"/><path d=\"M4 15a1 1 0 1 0 0-2H3a1 1 0 1 0 0 2zm18-1a1 1 0 0 1-1 1h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1M5.636 9.05A1 1 0 0 0 7.05 7.636l-.707-.707A1 1 0 1 0 4.93 8.343z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miSunset: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 16a4 4 0 1 1 6.646 3H9.354A4 4 0 0 1 8 16m.97 5H21a1 1 0 1 0 0-2h-3.803a6 6 0 1 0-10.394 0H3a1 1 0 1 0 0 2zM19.071 8.929a1 1 0 0 1 0 1.414l-.707.707a1 1 0 0 1-1.414-1.414l.707-.707a1 1 0 0 1 1.414 0M4 17a1 1 0 1 0 0-2H3a1 1 0 1 0 0 2zm18-1a1 1 0 0 1-1 1h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1M5.636 11.05A1 1 0 0 0 7.05 9.636l-.707-.707a1 1 0 1 0-1.414 1.414zM13 5.586V3a1 1 0 1 0-2 0v2.586l-.293-.293a1 1 0 0 0-1.414 1.414l1.999 1.999l.01.01a.997.997 0 0 0 1.406-.01l2-1.999a1 1 0 0 0-1.415-1.414z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miSwitch: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14.293 2.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L16.586 8H5a1 1 0 0 1 0-2h11.586l-2.293-2.293a1 1 0 0 1 0-1.414m-4.586 10a1 1 0 0 1 0 1.414L7.414 16H19a1 1 0 1 1 0 2H7.414l2.293 2.293a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miTable: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 5.5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm9 0H4v3h7zm2 0v3h7v-3zm7 5h-7v3h7zm0 5h-7v3h7zm-9 3v-3H4v3zm-7-5h7v-3H4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miTablet: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M4 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm14 0H6v16h12z\"/><path d=\"M13 18a1 1 0 1 1-2 0a1 1 0 0 1 2 0\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miTag: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M2 3a1 1 0 0 1 1-1h8a1 1 0 0 1 .707.293l10 10a1 1 0 0 1 0 1.414l-8 8a1 1 0 0 1-1.414 0l-10-10A1 1 0 0 1 2 11zm2 1v6.586l9 9L19.586 13l-9-9z\"/><path d=\"M9 7.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miTemperature: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 5a3 3 0 1 1 6 0v8a5 5 0 1 1-6 0zm3-1a1 1 0 0 0-1 1v8.535a1 1 0 0 1-.5.866a3 3 0 1 0 2.999 0a1 1 0 0 1-.499-.866V5a1 1 0 0 0-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miText: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v1a1 1 0 1 1-2 0V6h-4v12h1a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h1V6H7v1a1 1 0 0 1-2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miThreeRows: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19 2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 4V4H5v2zm0 10a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2zm0 4v-2H5v2zm0-11a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2zm0 4v-2H5v2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miTwoColumns: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm6 0H5v14h4zm4 0a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2zm6 0h-4v14h4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miTwoRows: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19 3a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm0 6V5H5v4zm0 4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2zm0 6v-4H5v4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miUnderline: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 4a1 1 0 1 0-2 0v7a4 4 0 0 1-8 0V4a1 1 0 1 0-2 0v7a6 6 0 0 0 12 0zM7 19a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miUndo: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12.207 2.293a1 1 0 0 1 0 1.414L10.914 5H12.5c4.652 0 8.5 3.848 8.5 8.5S17.152 22 12.5 22S4 18.152 4 13.5a1 1 0 1 1 2 0c0 3.548 2.952 6.5 6.5 6.5s6.5-2.952 6.5-6.5S16.048 7 12.5 7h-1.586l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miUnlock: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 4c-1.648 0-3 1.352-3 3v3h9a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h1V7c0-2.752 2.248-5 5-5s5 2.248 5 5a1 1 0 1 1-2 0c0-1.648-1.352-3-3-3m-6 8v8h12v-8z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miUser: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 4a4 4 0 1 0 0 8a4 4 0 0 0 0-8M6 8a6 6 0 1 1 12 0A6 6 0 0 1 6 8m2 10a3 3 0 0 0-3 3a1 1 0 1 1-2 0a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5a1 1 0 1 1-2 0a3 3 0 0 0-3-3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miUserAdd: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 4a4 4 0 1 0 0 8a4 4 0 0 0 0-8M4 8a6 6 0 1 1 12 0A6 6 0 0 1 4 8m15 3a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1M6.5 18C5.24 18 4 19.213 4 21a1 1 0 1 1-2 0c0-2.632 1.893-5 4.5-5h7c2.607 0 4.5 2.368 4.5 5a1 1 0 1 1-2 0c0-1.787-1.24-3-2.5-3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miUserCheck: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 4a4 4 0 1 0 0 8a4 4 0 0 0 0-8M4 8a6 6 0 1 1 12 0A6 6 0 0 1 4 8m17.664 3.253a1 1 0 0 1 .083 1.411l-2.666 3a1 1 0 0 1-1.495 0l-1.333-1.5a1 1 0 0 1 1.494-1.328l.586.659l1.92-2.16a1 1 0 0 1 1.411-.082M6.5 18C5.24 18 4 19.213 4 21a1 1 0 1 1-2 0c0-2.632 1.893-5 4.5-5h7c2.607 0 4.5 2.368 4.5 5a1 1 0 1 1-2 0c0-1.787-1.24-3-2.5-3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miUserRemove: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 4a4 4 0 1 0 0 8a4 4 0 0 0 0-8M4 8a6 6 0 1 1 12 0A6 6 0 0 1 4 8m12 6a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1m-9.5 4C5.24 18 4 19.213 4 21a1 1 0 1 1-2 0c0-2.632 1.893-5 4.5-5h7c2.607 0 4.5 2.368 4.5 5a1 1 0 1 1-2 0c0-1.787-1.24-3-2.5-3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miUsers: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 4a4 4 0 1 0 0 8a4 4 0 0 0 0-8M4 8a6 6 0 1 1 12 0A6 6 0 0 1 4 8m12.828-4.243a1 1 0 0 1 1.415 0a6 6 0 0 1 0 8.486a1 1 0 1 1-1.415-1.415a4 4 0 0 0 0-5.656a1 1 0 0 1 0-1.415m.702 13a1 1 0 0 1 1.212-.727c1.328.332 2.169 1.18 2.652 2.148c.468.935.606 1.98.606 2.822a1 1 0 1 1-2 0c0-.657-.112-1.363-.394-1.928c-.267-.533-.677-.934-1.349-1.102a1 1 0 0 1-.727-1.212zM6.5 18C5.24 18 4 19.213 4 21a1 1 0 1 1-2 0c0-2.632 1.893-5 4.5-5h7c2.607 0 4.5 2.368 4.5 5a1 1 0 1 1-2 0c0-1.787-1.24-3-2.5-3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miVolumeOff: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.418 2.091A1 1 0 0 1 14 3v18a1 1 0 0 1-1.65.76L5.63 16H3a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2.63l6.72-5.76a1 1 0 0 1 1.068-.149M12 5.175L6.65 9.76A1 1 0 0 1 6 10H4v4h2a1 1 0 0 1 .65.24L12 18.827V5.174zm4.293 4.119a1 1 0 0 1 1.414 0L19 10.586l1.293-1.293a1 1 0 1 1 1.414 1.414L20.414 12l1.293 1.293a1 1 0 0 1-1.414 1.414L19 13.414l-1.293 1.293a1 1 0 0 1-1.414-1.414L17.586 12l-1.293-1.293a1 1 0 0 1 0-1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miVolumeUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.418 2.091A1 1 0 0 1 14 3v18a1 1 0 0 1-1.65.76L5.63 16H3a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2.63l6.72-5.76a1 1 0 0 1 1.068-.149M12 5.175L6.65 9.76A1 1 0 0 1 6 10H4v4h2a1 1 0 0 1 .65.24L12 18.827V5.174zm5.293.119a1 1 0 0 1 1.414 0l.002.001l.001.002l.004.004l.01.01a3 3 0 0 1 .114.125c.07.08.165.194.274.34c.22.292.503.718.782 1.278C20.456 8.175 21 9.827 21 12s-.544 3.825-1.106 4.947c-.28.56-.562.986-.781 1.278a6 6 0 0 1-.389.465l-.01.01l-.004.004l-.001.002h-.001v.001a1 1 0 0 1-1.42-1.41l.005-.004l.04-.045q.061-.068.18-.223a6.4 6.4 0 0 0 .593-.972c.438-.878.894-2.226.894-4.053s-.456-3.175-.894-4.053a6.4 6.4 0 0 0-.594-.972a4 4 0 0 0-.22-.268l-.004-.005a1 1 0 0 1 .005-1.41zm-2 3a1 1 0 0 1 1.414 0l.002.001l.001.002l.003.003l.008.008l.02.02l.055.061a4.7 4.7 0 0 1 .599.914c.31.623.605 1.525.605 2.698s-.294 2.075-.606 2.697c-.154.31-.312.548-.438.716a3 3 0 0 1-.215.26l-.02.02l-.008.008l-.003.003l-.002.002a1 1 0 0 1-1.418-1.411a2.7 2.7 0 0 0 .315-.492c.19-.378.395-.976.395-1.803s-.206-1.425-.394-1.803a2.7 2.7 0 0 0-.316-.492a1 1 0 0 1 .002-1.412z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miWarning: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M12 14a1 1 0 0 1-1-1v-3a1 1 0 1 1 2 0v3a1 1 0 0 1-1 1m-1.5 2.5a1.5 1.5 0 1 1 3 0a1.5 1.5 0 0 1-3 0\"/><path d=\"M10.23 3.216c.75-1.425 2.79-1.425 3.54 0l8.343 15.852C22.814 20.4 21.85 22 20.343 22H3.657c-1.505 0-2.47-1.6-1.77-2.931zM20.344 20L12 4.147L3.656 20z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miWebcam: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M21.5 6.1c-.3-.2-.7-.2-1 0l-4.4 3V7c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-2.1l4.4 3c.2.1.4.2.6.2s.3 0 .5-.1c.3-.2.5-.5.5-.9V7c0-.4-.2-.7-.5-.9M14 17H4V7h10zm6-1.9l-4-2.7v-.9l4-2.7z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miWind: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18.806 12.919a4 4 0 1 0-3.787-6.586a1 1 0 0 0 1.49 1.334a2 2 0 0 1 1.695-.657A2 2 0 0 1 18 11H3a1 1 0 1 0 0 2h15q.415 0 .806-.081M5 10h5.516a2.5 2.5 0 1 0-1.88-4.167a1 1 0 0 0 1.491 1.334A.5.5 0 1 1 10.5 8H5a1 1 0 0 0 0 2m11.5 4H8a1 1 0 1 0 0 2h8.5a.5.5 0 1 1-.373.833a1 1 0 1 0-1.49 1.334A2.5 2.5 0 1 0 16.517 14z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miWindow: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm16 2v4H4V5zM4 11h16v8H4zm6-4a1 1 0 1 1-2 0a1 1 0 0 1 2 0M6 8a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miZoomIn: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 4a6 6 0 1 0 0 12a6 6 0 0 0 0-12m-8 6a8 8 0 1 1 14.32 4.906l5.387 5.387a1 1 0 0 1-1.414 1.414l-5.387-5.387A8 8 0 0 1 2 10m8-3a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1H8a1 1 0 1 1 0-2h1V8a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const miZoomOut: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 4a6 6 0 1 0 0 12a6 6 0 0 0 0-12m-8 6a8 8 0 1 1 14.32 4.906l5.387 5.387a1 1 0 0 1-1.414 1.414l-5.387-5.387A8 8 0 0 1 2 10m5 0a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}